import { Box, Divider } from "@mui/material";
import ThemeContext from "components/app/Context";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import SearchAppBar from "components/common/searchBar";
import BasicTable from "components/common/Table";
import Toggle from "components/common/Toggle";
import { useContext, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { fetchUnImplementedProperties } from "../../AboveProperty.slice";
import "./index.scss";
import { InProgressHeader } from "./TableHeadersConfig";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";

interface Props {
  toggleOn?: boolean;
  handleToggle: any;
  cmsId: any;
}

function UnImplementedProperties(props: Props) {
  const { handleToggle, toggleOn, cmsId } = props;

  const dispatch = useAppDispatch();
  const [pageNo, setPageNo] = useState(0);
  const { unImplementedProperties, unImplemenetedCount } = useAppSelector((state) => state.aboveProperty.planProgress);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { isMobileScreen } = useContext(ThemeContext);

  const pageName = filterPage.planProgressUnimplementedFromPlansDisplay;

  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[pageName]);

  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];

  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  formattedFilterRequestPayload["innCode"] =
    formattedFilterRequestPayload["innCode"] ?? location?.state?.progressInncodes?.join(", ");
  const searchText = globalFiltersforPage?.searchText ?? "";

  const apiCall = () => {
    const props = {
      searchedPropertyText: searchText,
      ...formattedFilterRequestPayload,
      size: PAGE_SIZE,
      page: pageNo,
      cmsId: cmsId
    };

    if (!toggleOn) dispatch(fetchUnImplementedProperties(props));
  };

  useEffect(() => {
    if (pageNo === 0) {
      apiCall();
    }
  }, [pageNo, searchText, filterRequestPayload]);

  useEffect(() => {
    setPageNo(0);
  }, [searchText, filterRequestPayload]);

  useEffect(() => {
    if (pageNo > 0) {
      apiCall();
    }
  }, [pageNo]);

  return (
    <>
      <Box sx={{ padding: "16px 8px" }}>
        <Box className="filter-searchbar-wrapper ">
          <SearchAppBar
            isPreDefinedNav={true}
            value={searchText}
            placeholder="Search by Property"
            sx={{
              minWidth: isMobileScreen ? "initial" : "350px",
              border: `solid 1px ${tokens.Border.General.Tertiary}`
            }}
            getInputDetails={(val) =>
              dispatch(
                setPageFilter({
                  pageName: pageName,
                  searchText: val
                })
              )
            }
          />

          <Box className="toggle-filters">
            <Toggle
              onChange={(val: boolean) => handleToggle(val)}
              isToggleEnabled={false}
              isLabelLeftSide={true}
              sx={{ marginTop: "4px", marginLeft: isMobileScreen ? "8px" : "20px" }}
            />

            <GlobalFilters page={pageName} />
          </Box>
        </Box>
        <GlobalFilterDescription page={pageName} bgColor={tokens.Background.General.Primary} />
      </Box>

      <Divider />
      <BasicTable
        id="tableDiv"
        totalRecords={unImplemenetedCount}
        pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
        data={{
          headers: InProgressHeader,
          rows: unImplementedProperties?.map((element: any) => {
            return {
              data: [
                {
                  content: element?.propertyName
                },
                { content: element?.innCode },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" }
              ]
            };
          })
        }}
      />
    </>
  );
}

export default UnImplementedProperties;
